<template>
  <v-card color="grey lighten-4" flat class="fill-height">
    <v-card-text>
      <v-row align="center" justify="space-between" no-gutters v-for="(contractKey, i) in contractKeys" :key="i"
        class="flex-nowrap">
        <v-col cols="auto">
          <Icon margin="mr-2" :icon="IconHelpers.getIconForObjectType(contractKey)" iconColor="grey darken-1"
            :small="false" :tooltipText="$t(contractKey)"></Icon>
        </v-col>
        <v-col class="text-right my-1">
          <Icon v-if="keyIsCertified(contractKey)" icon="mdi-certificate-outline" iconColor="info" :small="false"
            :tooltipText="$t('certified')" />
          <span class="subtitle-1" :style="{ lineHeight: '1' }">{{ contract[contractKey] }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import IconHelpers from '@/utils/IconHelpers'
import { CertificationStatus } from '@/utils/Enumerations'

export default {
  name: 'ContractKeyCard',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    contract: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    IconHelpers
  }),

  computed: {
    contractKeys () {
      var result = ['destination']
      if (this.contract.fromAccount) {
        result.unshift('account')
        result.unshift('fromAccount')
      }
      if (this.contract.tract) result.unshift('tract')
      if (this.contract.setting) result.push('setting')
      if (this.contract.tract) result.push('account')
      return result
    }
  },

  methods: {
    keyIsCertified (contractKey) {
      switch (contractKey) {
        case 'account': return this.contract.accountCertificationStatus === CertificationStatus.Active.value
        case 'tract': return this.contract.tractIsCertified
        default: return false
      }
    }
  }
}
</script>
